import { Grid2 as Grid } from '@mui/material';
import { Dropdown, TextArea, TextInput } from 'framework/form';
import { BOOLEAN_OPTIONS } from '../constants';

const BugForm = () => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextInput source="shortDescription" label="Short description" />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Dropdown source="isCritical" label="Critical" options={BOOLEAN_OPTIONS} placeholder="Select" />
      </Grid>
      <Grid size={6}>
        <TextInput source="linkToDetails" label="Link to details" />
      </Grid>
      <Grid size={12}>
        <TextArea source="notes" label="Notes" rows={4} />
      </Grid>
    </Grid>
  );
};

export default BugForm;
